/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { DropdownFeaturePage } from "components/header/header-nav-bar/dropdown-feature-page";

const DropdownMenu = (props) => {

    const childMenus = props?.childMenus;
    const show = props?.show ?? false;
    const title = props?.title;
    const url = props?.url;

    return (
        <>
            {show && (
                <div className='dropdown-menu'>
                    <div className='dropdown-menu-links'>
                        <a href={url}>View all</a>
                        <ul>
                            {childMenus.map((child, index) => {
                                const childTitle = child?.title ?? "";
                                const childUrl = child?.url ?? "";
                                const itemsPerColumn = Math.ceil(childMenus.length / 2);
                                const isFirstInColumn = index === 0 || index === itemsPerColumn;
                                return (
                                    <li
                                        className={isFirstInColumn ? "first-in-column" : ""}
                                        key={`child-${index}`}
                                    >
                                        <a href={childUrl}>{childTitle}</a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <DropdownFeaturePage menuTitle={title} />
                </div>
            )}
        </>
    );
};

export { DropdownMenu };
